<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>Today's Attendance</b-card-title>
      <b-card-text class="mr-25 mb-0">
        <!--        August 4th 2022, 7:09 AM-->
      </b-card-text>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          md="3"
          sm="6"
          class="mb-2 mb-md-0"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-success"
              >
                <feather-icon
                  size="24"
                  icon="UsersIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ attendanceToday.males_present }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                Males Present
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          md="3"
          sm="6"
          class="mb-2 mb-md-0"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-success"
              >
                <feather-icon
                  size="24"
                  icon="UsersIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ attendanceToday.females_present }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                Females Present
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          md="3"
          sm="6"
          class="mb-2 mb-md-0"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-danger"
              >
                <feather-icon
                  size="24"
                  icon="UsersIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ attendanceToday.males_absent }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                Males Absent
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          md="3"
          sm="6"
          class="mb-2 mb-md-0"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-danger"
              >
                <feather-icon
                  size="24"
                  icon="UsersIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ attendanceToday.females_absent }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                Females Absent
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  data() {
    return {
    }
  },
  computed: {
    attendanceToday() {
      return this.$store.getters['dashboard/students']?.attendanceToday
    },
  },
}
</script>
